import { Col, Row, Skeleton } from 'antd';
import React from 'react';

import MonthlyDeliveries from './MonthlyDeliveries/index';
import DelayedDeliveries from './DelayedDeliveries/index';
import TotalWorkOrderAverageTicket from './TotalWorkOrderAverageTicket';
import MonthlyTotalWorkOrderAverageTicket from './MonthlyTotalWorkOrderAverageTicket';
import PartsAndServicesChart from './../Mock/MockCharts/PartsAndServicesChart/index';
import FinancialChart from '@/components/Dashboard/Mock/MockCharts/FinancialChart/FinancialChart';
import AverageTicketChart from '@/components/Dashboard/Mock/MockCharts/AverageTicketChart';
import HomeWorkOrders from '@/components/Dashboard/Mock/HomeWorkOrders';
import EmployeesTeam from '@/components/Dashboard/Mock/HomeEmployeesTeam';
import { DashboardType } from '@/core/domain/workorder/Dashboard/Dashboard.types';
import { useDashboardData } from '@/core/domain/workorder/Dashboard/Dashboard.hooks';
import MonthlyTotalWorkOrderAverageRealTicket from './MonthlyTotalWorkOrderAverageRealTicket';

const DashboardManagerView: React.FC = () => {
  const { data, isLoading } = useDashboardData({
    dashboardType: DashboardType.management,
  });

  return (
    <Skeleton active loading={isLoading} paragraph={{ rows: 10 }}>
      <Row gutter={[16, 16]}>
        <Col span={24} sm={12} md={12} lg={12} xl={5}>
          <TotalWorkOrderAverageTicket value={data?.averageTicketTotal} />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={5}>
          <MonthlyTotalWorkOrderAverageTicket
            value={data?.averageTicketMonth}
          />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={5}>
          <MonthlyTotalWorkOrderAverageRealTicket
            value={data?.averageTicketRealMonth}
          />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={5}>
          <MonthlyDeliveries value={data?.deliveryMonth} />
        </Col>

        <Col span={24} /*sm={12} md={12} lg={12}*/ xl={4}>
          <DelayedDeliveries value={data?.deliveryExpired} />
        </Col>

        <Col span={24} lg={12} xxl={8}>
          <PartsAndServicesChart />
        </Col>

        <Col span={24} lg={12} xxl={8}>
          <FinancialChart />
        </Col>

        <Col span={24} xxl={8}>
          <AverageTicketChart />
        </Col>

        <Col span={24} lg={16}>
          <HomeWorkOrders />
        </Col>

        <Col span={24} lg={8}>
          <EmployeesTeam />
        </Col>
      </Row>
    </Skeleton>
  );
};

export default DashboardManagerView;
